<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">Potwierdź udział</span>
            <button mat-icon-button (click)="matDialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <form [formGroup]="form" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto">

            <p>Zweryfikuj czy jeden z treningów/zabiegów z listy to ten Twój - jeśli tak wybierz go</p>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">

                    <mat-label>{{'Reservation'|translate}}</mat-label>
                    <mat-select formControlName="id">
                        <mat-option [value]="reservation.id" *ngFor="let reservation of reservations">
                            <span *ngIf="!reservation.groupActivity">{{reservation.customer.firstName}} {{reservation.customer.lastName}} - </span>
                            <span *ngIf="reservation.groupActivity">{{'Group activity'|translate}} - </span>
                            <span *ngIf="reservation.service">{{reservation.service.name}} -</span>
                            ({{reservation.startDate|date: 'dd.MM.y HH:mm':'UTC': 'pl'}} -
                            {{reservation.endDate|date: 'HH:mm':'UTC': 'pl'}})
                        </mat-option>
                    </mat-select>
                    <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                </mat-form-field>
            </div>
        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close({status: 'cancel'})"
                aria-label="OK"
                matTooltip="OK">
            Nie
        </button>

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close({status: 'ok', 'form': form})"
                [disabled]="form.invalid"
                aria-label="OK"
                matTooltip="OK">
            Tak
        </button>

    </div>
</div>
